<template>
  <div>
    <v-toolbar flat :color="ui.bkgdColor">
      <v-toolbar-title>
        <div :class="ui.textWarning"
        v-if="this.getDetailBasic.ver === 'A'">
          Archived
        </div>
        <div :class="ui.textBlue1"
        v-else-if="this.getDetailBasic !== null && this.getDetailBasic.act === true">
          <span class="hidden-xs-only">
            {{getDetailBasic.title}}
          </span>
        </div>
        <div v-else :class="ui.textWarning">
          Locked
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip :color="ui.bkgdColor" :text-color="dataSavePendingColor"
      v-if="enablePendingIndication">
        <v-icon> cloud </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="ui.colorWarning"
      v-if="this.getDetailBasic !== null && this.getDetailBasic.act === false">
        <v-icon :color="ui.btnWarning"> lock </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="ui.colorWarning"
      v-if="this.getDetailBasic.ver === 'A'">
        <v-icon :color="ui.colorWarning">
          archive
        </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="ui.colorWarning"
      v-if="this.getDetailBasic.tag === 'E8'">
        <v-icon :color="ui.colorBlue" v-if="this.getDetailChar.stat === true">
          verified
        </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="ui.colorWarning"
      v-if="
      this.enableTransIcons === true &&
      this.getTransitions !== null &&
      this.getTransitions !== undefined
      ">
        <v-icon :color="ui.colorBlue">
          {{transStatusIcon}}
        </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="ui.colorWarning">
        <v-icon left :color="ui.colorBlue">
          {{this.defineDocumentFromTag(this.localForm.tag).icon}}
        </v-icon>
        <div :class="ui.textSubheading">
          {{displayDocumentIDGTypeA(this.localForm.tag, this.localForm.idg)}}
        </div>
      </v-chip>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
export default {
  // eslint-disable-next-line
  mixins: [apptheme, describeDocument, displayFunctions],
  data() {
    return {
      valid: true,
      localForm: {
        tag: "B1",
        idg: "123"
      }
    };
  },
  beforeMount() {
    // Prepare for doc log
    // this.prepareForDocumentLog();
    // Reload STATS (to cater for race conditions)
    // fix orginal data before change
    this.localForm.tag = this.getDetailBasic.tag;
    this.localForm.idg = this.getDetailBasic.idg;
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetailBasic",
      "getDetailChar",
      "getDataSavePendingIndication",
      "getTransitions"
    ]),
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    },
    transStatusIcon() {
      // APPROVED TRANS is in DETAIL
      let icon = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        icon = flow[flow.length - 1].icon;
      }
      return icon;
    },
    enableTransIcons() {
      let logic = null;
      let tag = this.getDetailBasic.tag;
      if (
        tag === "B4" ||
        tag === "B6" ||
        tag === "G1" ||
        tag === "E2" ||
        tag === "Q1" ||
        tag === "M2" ||
        tag === "S6" ||
        tag === "W1" ||
        tag === "W2" ||
        tag === "W2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enablePendingIndication() {
      let logic = null;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      if (status === "Closed") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    }
  }
};
</script>
